/**
 * ThumbnailImg — AC3: fetches signed GCS URL for a video thumbnail (24h TTL).
 * Uses React Query for deduplication; falls back to placeholder on error.
 */
import { useQuery } from '@tanstack/react-query';

const API_BASE = import.meta.env.VITE_API_URL ?? 'http://localhost:8001';

interface Props {
  videoId: string;
  alt: string;
  className?: string;
}

async function fetchThumbnailUrl(videoId: string): Promise<string | null> {
  const token = localStorage.getItem('token') ?? '';
  const res = await fetch(`${API_BASE}/api/v1/knowledge/videos/${videoId}/thumbnail-url`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return null;
  const { url } = await res.json();
  return url as string;
}

export default function ThumbnailImg({ videoId, alt, className }: Props) {
  const { data: url } = useQuery<string | null>({
    queryKey: ['thumbnail-url', videoId],
    queryFn: () => fetchThumbnailUrl(videoId),
    staleTime: 23 * 60 * 60 * 1000, // 23h (backend TTL is 24h)
    retry: false,
  });

  if (!url) return null;
  return <img src={url} alt={alt} className={className} />;
}
